import { CssBaseline } from '@mui/material';
import AppRoutes from './routes/AppRoutes';
import './App.css';
import 'videojs-contrib-quality-levels';
import 'jb-videojs-hls-quality-selector';
import 'video.js/dist/video-js.css';

const App = () => {
  return (
    <>
      <CssBaseline />
      <AppRoutes />
    </>
  );
};

export default App;
